module.exports = __webpack_public_path__ + "static/mujeres005.thumb-1ca7d03a3122825295aceabbab8d3f37.jpg";